
import { Injectable, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AG_GRID_LOCALE_BR, AG_GRID_LOCALE_EN, AG_GRID_LOCALE_ES, AG_GRID_LOCALE_FR,
    AG_GRID_LOCALE_DE, AG_GRID_LOCALE_IT,  AG_GRID_LOCALE_CN,   AG_GRID_LOCALE_JP,
 } from '@ag-grid-community/locale';
import { MatPaginatorIntl } from "@angular/material/paginator";
import { Subject, Subscription } from "rxjs";
import { HTTPService } from "./http.service";
import { de_DE, en_US, es_ES, fr_FR, it_IT, ja_JP, NzI18nService, pt_BR, zh_CN } from "ng-zorro-antd/i18n";

 
 
 @Injectable()
 export class CustomPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
    OF_LABEL = 'of';
    unsubscribe: Subscription = null;

   constructor(private translate: TranslateService) {
     super();
     this.translateLabels();
     this.unsubscribe = this.translate.onLangChange.subscribe(() => this.translateLabels());
   }

   ngOnDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe.unsubscribe();
    }
    
  }
 
   translateLabels() {
     this.itemsPerPageLabel = this.translate.instant('PAGINATOR.ITEMS_PER_PAGE');
     this.nextPageLabel = this.translate.instant('PAGINATOR.NEXT_PAGE');
     this.previousPageLabel = this.translate.instant('PAGINATOR.PREVIOUS_PAGE');
     this.firstPageLabel = this.translate.instant('PAGINATOR.FIRST_PAGE');
     this.lastPageLabel = this.translate.instant('PAGINATOR.LAST_PAGE');
     this.OF_LABEL = this.translate.instant('PAGINATOR.OF_LABEL');
     this.changes.next();
   }

   getRangeLabel = (
    page: number,
    pageSize: number,
    length: number,
  ) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.OF_LABEL} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${
      this.OF_LABEL
    } ${length}`;
  };
   
 }
 


@Injectable({
  providedIn: 'root'
})

export class LanguageServices {

    language  = 'pt-BR';
    languages = [
        {col:'PTBR', id: 'pt-BR', name: 'Português', gridLocale: AG_GRID_LOCALE_BR,ISO639: 'pt-BR', zn:pt_BR },
        {col:'ENUS', id: 'en-US', name: 'English', gridLocale: AG_GRID_LOCALE_EN, ISO639: 'en', zn:en_US },
        {col:'ESES', id: 'es-ES', name: 'Español', gridLocale: AG_GRID_LOCALE_ES, ISO639: 'es', zn:es_ES },
        {col:'FRFR', id: 'fr-FR', name: 'Français', gridLocale: AG_GRID_LOCALE_FR, ISO639: 'fr', zn:fr_FR },
        {col:'DEDE', id: 'de-DE', name: 'Deutsch', gridLocale: AG_GRID_LOCALE_DE, ISO639: 'de', zn:de_DE },
        {col:'ITIT', id: 'it-IT', name: 'Italiano', gridLocale: AG_GRID_LOCALE_IT, ISO639: 'it', zn:it_IT },
        {col:'JAJP', id: 'ja-JP', name: '日本語', gridLocale: AG_GRID_LOCALE_JP,   ISO639: 'ja', zn:ja_JP },
        {col:'ZHCN', id: 'zh-CN', name: '中文', gridLocale: AG_GRID_LOCALE_CN, ISO639: 'zh', zn:zh_CN },
    ];
    sub: Subscription;
    constructor(private translateService:TranslateService,
                private http:HTTPService,
                private nzI18nService:NzI18nService 
    ){

    }

    ngOnDestroy() {
        if (this.sub!=null) {
            this.sub.unsubscribe();
        }
    }

    instant(key: string,params?: Object): string {
        if ( key==null || key.trim()==''){
            return key;
        }
        return this.translateService.instant(key.toUpperCase(), params);
    }

    

    changeLanguage(language: string) {
        this.language = language;
        let currentLanguage = this.language;
        this.nzI18nService.setLocale(this.languages.find((lang) => lang.id === currentLanguage).zn);
        return new Promise((resolve, reject) => {
            this.translateService.use(language);    
            localStorage.setItem('language',language);
        });
    }

    setDefaultLanguage() {
        this.translateService.setDefaultLang('pt-BR');
        this.translateService.use('pt-BR');
        this.nzI18nService.setLocale(pt_BR);
    }

    public getCurrentGridLocale() {
        let currentLanguage = this.language;
        let gridLocale = this.languages.find((lang) => lang.id === currentLanguage);
        return gridLocale ? gridLocale.gridLocale : AG_GRID_LOCALE_BR;
    }


    public getGoogleTranslationLanguages(toTranslate: string, fromLanguage: string, toLanguage: string): Promise<any> {
        
        let fromLanguageISO = this.languages.find((lang) => lang.col == fromLanguage).ISO639;
        let toLanguageISO = this.languages.find((lang) => lang.col == toLanguage).ISO639;

        return new Promise((resolve, reject) => {
            let ob = {
                "expressao": "getRequestData(GetTranslation,Product,{@PARAM},GET,null,'Content-Type:application/json',{@CODEMKTP})",
                "novo": true,
                "codecompany": 1,
                "codemktp": 139,
                "codecontract": 0,
                "values":[] 
              }
          
              let param = {
                key:'@PARAM',
                value:`?q=encodeString(${toTranslate})&origin=${fromLanguageISO}&target=${toLanguageISO}&key=executeSql(APIKEY,MKTPACTIVECOMPANIES,CODECOMPANY=1 AND CODEMKTP=139)`
              }
              
              ob['values'].push(param);
              
              this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(data=>{
                  resolve(data['resultado']);
              },error=>{
                  reject(error.toString());
              },()=>{
              })    
        });

        

    }

}